module.exports = __webpack_public_path__ + "media/images/favicon-172b669b482ee20768134c803a5e4417.png";